import { useEffect, useState } from 'react';
import { Page, Header, Content, Progress, Table, TableColumn, Link, ResponseErrorPanel } from '@backstage/core-components';
import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { Entity } from '@backstage/catalog-model';

export const RadarsPage = () => {
  const catalogApi = useApi(catalogApiRef);
  const [radars, setRadars] = useState<Entity[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | undefined>();

  useEffect(() => {
    let active = true;
    setLoading(true);
    catalogApi
      .getEntities({ filter: { kind: ['Radar'] } })
      .then(res => {
        if (active) setRadars(res.items ?? []);
      })
      .catch(e => {
        if (active) setError(e);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [catalogApi]);

  if (loading) {
    return (
      <Page themeId="tool">
        <Header title="Radars" subtitle="All radars from your catalog" />
        <Content>
          <Progress />
        </Content>
      </Page>
    );
  }

  if (error) {
    return (
      <Page themeId="tool">
        <Header title="Radars" />
        <Content>
          <ResponseErrorPanel error={error} />
        </Content>
      </Page>
    );
  }

  const columns: TableColumn[] = [
    { title: 'Name', field: 'name' },
    { title: 'Namespace', field: 'namespace' },
    { title: 'Description', field: 'description' },
    { title: 'Open', field: 'open', width: '80px' },
  ];

  const data = radars.map(e => {
    const namespace = e.metadata.namespace ?? 'default';
    const name = e.metadata.name;
    const kind = (e.kind || 'Radar').toLowerCase();
    return {
      name: (e.metadata as any).title ?? e.metadata.name,
      namespace,
      description: e.metadata.description ?? '',
      open: <Link to={`/tech-radar/${namespace}/${kind}/${name}`}>Open</Link>,
    };
  });

  return (
    <Page themeId="tool">
      <Header title="Radars" subtitle={radars.length ? `Found ${radars.length} radars` : undefined} />
      <Content>
        {radars.length === 0 ? (
          <div>No radars found. Ensure your GitLab providers are ingesting and the GS Technologies provider is generating Radar entities.</div>
        ) : (
          <Table
            title="All Radars"
            options={{ paging: false, search: false, padding: 'dense' }}
            columns={columns}
            data={data}
          />
        )}
      </Content>
    </Page>
  );
};
